module.exports = __webpack_public_path__ + "img/Toyota-2019-Highlander-2.ab532d28.png";